import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { DropdownBox, InputBox, SubmitButton } from "../../components/Input";
import { API_URL } from "../../config";
import axios from "axios";
import StateManagedSelect from "react-select";
import { showToast } from "../../components/toast";

const EmailMappingForm = () => {
  const [operation, setOperation] = useState("Add");
  const [valLocationName, setValLocationName] = useState("");
  const [selectedEmailId, setSelectedValEmailId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sendList, setSendList] = useState([]);
  const token = localStorage.getItem("authToken");
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchSendList = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}settings/emailMapping/dropdown-options`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setSendList(
        response.data.data.map((list) => ({
          value: list.id,
          label: list.emailFrom,
        }))
      ); // Adjust this path if the API structure differs
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmailMapping = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}settings/emailMapping/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const emailMapping = response.data.data;
      setValLocationName(emailMapping.location_name);
      setSelectedValEmailId(emailMapping.emailid);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      await fetchSendList();
      if (id) {
        setOperation("Edit");
        await fetchEmailMapping();
      }
    };
    init();
  }, [id]);

  useEffect(() => {
    if (operation === "Edit" && sendList.length > 0 && selectedEmailId) {
      const matchingOption = sendList.find(
        (item) => item.value === parseInt(selectedEmailId)
      );
      if (matchingOption) {
        setSelectedValEmailId(matchingOption); // set object, not .value
      }
    }
  }, [sendList, selectedEmailId, operation]);

  const handleEmailIdChange = (selectedOption) => {
    setSelectedValEmailId(selectedOption); // store the whole object
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        `${API_URL}settings/emailMapping/save`,
        {
          id: parseInt(id),
          location_name: valLocationName,
          emailid: selectedEmailId?.value,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === true) {
        showToast.success(response.data.message);
        navigate("/Settings/EmailMapping");
      }
    } catch (error) {
      showToast.error(error);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        {/* Dummy alertbox component */}
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form
            onSubmit={handleSubmit}
            name="frm1"
            className="stdform"
            encType="multipart/form-data"
          >
            <div className="panel-heading border-0">
              <span className="panel-title">{operation} Email Mapping</span>
            </div>
            <div className="panel-body">
              <div className="row">
                {/* Offer Code Text */}
                <div className="col-md-4 mb-2">
                  <label className="control-label">Location Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={valLocationName}
                    onChange={(e) => setValLocationName(e.target.value)}
                    placeholder="Enter Location Name"
                    disabled={operation === "Edit"} // Disable input for "Edit" operation
                  />
                </div>

                {/* Upload Offer Image */}
                <div className="col-md-4">
                  <label className="control-label">Select Email</label>
                  <StateManagedSelect
                    options={sendList}
                    value={selectedEmailId}
                    onChange={handleEmailIdChange}
                    placeholder="Select Email"
                  />
                </div>
              </div>
              <div className="clearfix"></div>
              <SubmitButton
                pageBack="/Settings/EmailMapping"
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>
        {/* Scroll to Top Button */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default EmailMappingForm;
